/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function () {
  if (window.__rsBoostCustomInitialized) return;
  window.__rsBoostCustomInitialized = true;

  let rsTotals = { from: null, to: null, total: null, fromBoost: false };

  function getInitialProductTotal() {
    return (
      window.boostSDFallback?.totalProductCount ||
      window.boostSDFallback?.pagination?.items ||
      null
    );
  }
  function getImageUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    if (Array.isArray(value)) return getImageUrl(value[0]);
    return getImageUrl(value.src || value.url || value.preview_image);
  }

  function isUsableImageSrc(src) {
    if (!src) return false;
    return !/^(data:|about:blank)/i.test(src) && !/placeholder|blank_image|no-image|default-image/i.test(src);
  }

  function getPrimaryVariant(product) {
    const variants = product?.variants;
    if (!Array.isArray(variants) || !variants.length) return null;

    return variants.reduce((best, variant) => {
      if (!best) return variant;
      const bestPos = Number(best.position);
      const nextPos = Number(variant.position);
      if (Number.isFinite(nextPos) && (!Number.isFinite(bestPos) || nextPos < bestPos)) {
        return variant;
      }
      return best;
    }, null);
  }

  const listingImageFetches = {};

  function listingImageFromMap(productId) {
    if (productId == null) return '';
    const images = window.rsProductImages || {};
    return images[productId] || images[String(productId)] || '';
  }

  function getProductHandle(product, item) {
    if (product?.handle) return product.handle;

    const fallback = findProductData(product?.id);
    if (fallback?.handle) return fallback.handle;

    const href = item?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getProductImageSrc(product) {
    if (!product) return '';

    const mapped = listingImageFromMap(product.id);
    if (mapped) return mapped;

    const productSrc =
      getImageUrl(product.featured_image) ||
      getImageUrl(product.featured_media) ||
      getImageUrl(product.image) ||
      getImageUrl(product.images);
    if (productSrc) return productSrc;

    const productMeta =
      product.metafields?.custom?.data?.value?.images || product.metafields?.custom?.data?.images;
    const productMetaSrc = getImageUrl(productMeta);
    if (productMetaSrc) return productMetaSrc;

    const variant = getPrimaryVariant(product);
    if (!variant) return '';

    return (
      getImageUrl(variant.featured_image) ||
      getImageUrl(variant.featured_media) ||
      getImageUrl(variant.image) ||
      getImageUrl(variant.images) ||
      getImageUrl(variant.metafields?.custom?.data?.value?.images) ||
      getImageUrl(variant.metafields?.custom?.data?.images)
    );
  }

  function getArtist(product) {
    if (!product) return '';

    const tags = product.tags || [];
    for (let i = 0; i < tags.length; i += 1) {
      const tag = String(tags[i]);
      if (tag.indexOf('Artist:') === 0) {
        return tag.split(':').slice(1).join(':').trim();
      }
    }

    const vendor = product.vendor ? String(product.vendor).trim() : '';
    if (vendor && !/^record\s*store$/i.test(vendor)) return vendor;

    return '';
  }

  function stripCadSuffix(text) {
    return String(text).replace(/\s*CAD\s*$/i, '').trim();
  }

  function formatMoneyFromCents(cents) {
    if (cents == null || Number.isNaN(Number(cents))) return '';

    const amount = (Number(cents) / 100).toFixed(2);
    const format =
      window.boostSDFallback?.moneyFormatWithCurrency ||
      window.boostSDAppConfig?.shop?.money_format_with_currency ||
      '${{amount}} CAD';

    const withAmount = format
      .replace(/\{\{\s*amount\s*\}\}/gi, amount)
      .replace(/&amp;/g, '&')
      .replace(/&#36;/g, '$')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');

    return stripCadSuffix(withAmount.replace(/<[^>]*>/g, ''));
  }

  function toCents(value) {
    const num = Number(value);
    if (Number.isNaN(num)) return null;

    if (String(value).includes('.') && num < 1000) {
      return Math.round(num * 100);
    }

    return num;
  }

  function getMinPriceCents(product) {
    if (!product) return null;

    const candidates = [product.price_min, product.min_price, product.price];

    for (const candidate of candidates) {
      if (candidate == null) continue;
      const cents = toCents(candidate);
      if (cents != null && !Number.isNaN(cents)) return cents;
    }

    if (Array.isArray(product.variants) && product.variants.length) {
      const prices = product.variants
        .map((variant) => toCents(variant.price))
        .filter((price) => price != null && !Number.isNaN(price));

      if (prices.length) return Math.min(...prices);
    }

    return null;
  }

  function hasMultipleVariants(product, priceTarget) {
    if (product) {
      const count = product.variants?.length ?? product.variant_count ?? 0;
      if (count > 1) return true;
    }

    return /from/i.test(priceTarget?.textContent || '');
  }

  function parsePriceFromText(text) {
    const normalized = String(text).replace(/\s+/g, ' ').trim();
    const fromMatch = normalized.match(/from\s+(\$[\d,]+(?:\.\d{2})?)/i);
    if (fromMatch) {
      return { amount: fromMatch[1], showFrom: true, key: `from-${fromMatch[1]}` };
    }

    const amountMatch = normalized.match(/(\$[\d,]+(?:\.\d{2})?)/);
    if (amountMatch) {
      return { amount: amountMatch[1], showFrom: false, key: amountMatch[1] };
    }

    return null;
  }

  function getPriceInfo(product, priceTarget) {
    const minCents = getMinPriceCents(product);
    if (minCents != null && !Number.isNaN(minCents)) {
      const amount = formatMoneyFromCents(minCents);
      if (amount) {
        const showFrom = hasMultipleVariants(product, priceTarget);
        return { amount, showFrom, key: `${showFrom ? 'from' : 'price'}-${minCents}` };
      }
    }

    return parsePriceFromText(priceTarget?.textContent || '');
  }

  function renderPrice(priceTarget, product) {
    if (!priceTarget) return;

    const info = getPriceInfo(product, priceTarget);
    if (!info) return;

    if (priceTarget.dataset.rsPriceKey === info.key && priceTarget.querySelector('.product-tile__price-amount')) {
      return;
    }

    priceTarget.dataset.rsPriceKey = info.key;
    priceTarget.classList.add('product-tile__price');
    priceTarget.innerHTML = '';

    if (info.showFrom) {
      const fromEl = document.createElement('span');
      fromEl.className = 'product-tile__price-from';
      fromEl.textContent = 'From ';
      priceTarget.appendChild(fromEl);
    }

    const amountEl = document.createElement('span');
    amountEl.className = 'product-tile__price-amount';
    amountEl.textContent = info.amount;
    priceTarget.appendChild(amountEl);

    const currencyEl = document.createElement('span');
    currencyEl.className = 'product-tile__currency';
    currencyEl.textContent = ' CAD';
    priceTarget.appendChild(currencyEl);
  }

  function ensureArtist(item, title, artist) {
    if (!title || !artist) return;

    let artistEl = item.querySelector('.product-tile__artist');
    if (!artistEl) {
      artistEl = document.createElement('p');
      artistEl.className = 'product-tile__artist';
      title.parentNode.insertBefore(artistEl, title);
    }

    artistEl.textContent = artist;
  }

  function normalizeProductBody(item) {
    const info = item.querySelector('.boost-sd__product-info');
    const content = item.querySelector('.boost-sd__product-content');

    if (info && content && info.contains(content)) {
      while (content.firstChild) {
        info.appendChild(content.firstChild);
      }
      content.remove();
    }

    item
      .querySelectorAll(
        '.boost-sd__product-vendor, .card__vendor, .boost-sd__product-add-to-cart, .boost-sd__button, .boost-sd__fallback-button, form[action*="/cart/add"]'
      )
      .forEach((el) => el.remove());

    return (
      item.querySelector('.boost-sd__product-info') ||
      item.querySelector('.boost-sd__product-content') ||
      item.querySelector('.boost-sd__fallback-product-item > div:last-child') ||
      item.querySelector('.card__content') ||
      item.querySelector('.card__information')
    );
  }

  function enhanceItem(item, product) {
    if (!item) return;

    item.classList.add('product-tile');

    const imageTarget =
      item.querySelector('.boost-sd__product-image-wrapper') ||
      item.querySelector('.boost-sd__product-image') ||
      item.querySelector('.boost-sd__fallback-product-media') ||
      item.querySelector('.card__media') ||
      item.querySelector('.media');

    if (imageTarget) {
      imageTarget.classList.add('product-tile__media');

      if (!imageTarget.querySelector('.product-tile__vinyl')) {
        const vinyl = document.createElement('div');
        vinyl.className = 'product-tile__vinyl';
        vinyl.setAttribute('aria-hidden', 'true');
        imageTarget.prepend(vinyl);
      }
    }

    applyListingImage(item, product, imageTarget);

    const infoTarget = normalizeProductBody(item);

    if (infoTarget) {
      infoTarget.classList.add('product-tile__body');
    }

    const title =
      item.querySelector('.boost-sd__product-title') ||
      item.querySelector('.boost-sd__fallback-product-title') ||
      item.querySelector('.card__heading a') ||
      item.querySelector('.card__heading');

    if (title) {
      title.classList.add('product-tile__title');
    }

    let artist = getArtist(product);
    if (!artist) {
      const vendorText = item.querySelector('.boost-sd__product-vendor, .card__vendor')?.textContent?.trim();
      if (vendorText && !/^record\s*store$/i.test(vendorText)) {
        artist = vendorText;
      }
    }

    if (title && artist) {
      ensureArtist(item, title, artist);
    }

    const priceTarget =
      item.querySelector('.boost-sd__product-price-wrapper') ||
      item.querySelector('.boost-sd__fallback-product-price-wrapper') ||
      item.querySelector('.boost-sd__product-price') ||
      item.querySelector('.price');

    if (priceTarget) {
      renderPrice(priceTarget, product);
    }

    item.dataset.rsBoostEnhanced = 'true';
  }

  function findCardImage(item) {
    return (
      item.querySelector('.boost-sd__product-image img') ||
      item.querySelector('.boost-sd__fallback-product-image') ||
      item.querySelector('.card__media img') ||
      item.querySelector('.media img') ||
      item.querySelector('.product-tile__image')
    );
  }

  function findCardImageTarget(item) {
    return (
      item.querySelector('.boost-sd__product-image-wrapper') ||
      item.querySelector('.boost-sd__product-image') ||
      item.querySelector('.boost-sd__fallback-product-media') ||
      item.querySelector('.card__media') ||
      item.querySelector('.media') ||
      item.querySelector('.product-tile__media')
    );
  }

  function applyImageSrc(item, product, imageTarget, src) {
    if (!item || !src) return null;

    let image = findCardImage(item);
    const target = imageTarget || findCardImageTarget(item);

    if (image && isUsableImageSrc(image.getAttribute('src') || image.src)) {
      image.classList.add('product-tile__image');
      return image;
    }

    if (!image && target) {
      image = document.createElement('img');
      image.alt = product?.title || '';
      image.width = 533;
      image.height = 533;
      image.loading = 'lazy';
      target.appendChild(image);
    }

    if (image) {
      image.src = src;
      image.removeAttribute('srcset');
      image.classList.add('product-tile__image');
    }

    return image;
  }

  function fetchListingImage(handle) {
    if (!handle) return Promise.resolve('');
    if (listingImageFetches[handle]) return listingImageFetches[handle];

    listingImageFetches[handle] = fetch(`/products/${handle}?view=listing-image`)
      .then((res) => (res.ok ? res.text() : ''))
      .then((text) => {
        const match = String(text).match(/\{[\s\S]*\}/);
        const data = match ? JSON.parse(match[0]) : null;
        const src = data?.src || '';
        if (src && data?.id != null) {
          window.rsProductImages = window.rsProductImages || {};
          window.rsProductImages[data.id] = src;
          window.rsProductImages[String(data.id)] = src;
        }
        return src;
      })
      .catch(() => '');

    return listingImageFetches[handle];
  }

  function applyListingImage(item, product, imageTarget) {
    const imageSrc =
      getProductImageSrc(product) ||
      getProductImageSrc(findProductData(product?.id)) ||
      listingImageFromMap(item?.getAttribute('data-product-id'));

    if (imageSrc) {
      applyImageSrc(item, product, imageTarget, imageSrc);
      return;
    }

    const existing = findCardImage(item);
    if (existing) existing.classList.add('product-tile__image');

    const handle = getProductHandle(product, item);
    if (!handle) return;

    fetchListingImage(handle).then((src) => {
      if (!src) return;
      const liveItem =
        document.querySelector(
          `.boost-sd__product-item[data-product-id="${product?.id}"], .boost-sd__fallback-product-item[data-product-id="${product?.id}"]`
        ) || item;
      applyImageSrc(liveItem, product, null, src);
    });
  }

  function findProductData(productId) {
    return (
      window.boostSDFallback?.products?.find((entry) => String(entry.id) === String(productId)) ||
      null
    );
  }

  function enhanceProductCards(root) {
    const scope = root || document;
    const items = scope.querySelectorAll(
      '.boost-sd__product-item[data-product-id], .boost-sd__fallback-product-item[data-product-id]'
    );

    items.forEach((item) => {
      const productId = item.getAttribute('data-product-id');
      enhanceItem(item, findProductData(productId));
    });
  }

  function getFilterSidebar() {
    return (
      document.querySelector('.boost-sd-left') ||
      document.querySelector('.boost-sd__filter-tree-wrapper')
    );
  }

  let sidebarEnhanceQueued = false;
  let sidebarEnhancing = false;

  function enhanceFilterCounts(sidebar) {
    if (!sidebar) return;

    sidebar.querySelectorAll('[class*="filter-option-item-amount"]').forEach((el) => {
      const count = el.textContent.replace(/[()]/g, '').trim();
      if (!count) return;
      if (el.dataset.rsCount === count) return;
      el.dataset.rsCount = count;
    });
  }

  function enhanceRefineBy() {
    const sidebar = getFilterSidebar();
    if (!sidebar) return;

    sidebar.querySelectorAll('[class*="refine-by-vertical-refine-by-heading"]').forEach((heading) => {
      const text = heading.textContent.trim();
      if (/^(filter|refine)(\s*by)?$/i.test(text)) {
        heading.textContent = 'Filters';
      }
    });

    sidebar.querySelectorAll('[class*="refine-by-vertical-refine-by-title"] > [class*="button"], [class*="refine-by-vertical-refine-by-title"] > button').forEach((button) => {
      if (/clear(\s*all)?/i.test(button.textContent.trim())) {
        button.textContent = 'Clear';
      }
    });
  }

  function getToolbar() {
    return document.querySelector('.boost-sd__toolbar');
  }

  function getPerPage() {
    const enhanced = document.querySelector('.rs-boost-toolbar-value')?.textContent?.trim();
    if (enhanced) return parseInt(enhanced, 10);

    const match = document
      .querySelector('.boost-sd__show-limit-list-button')
      ?.textContent?.match(/(\d+)/);
    if (match) return parseInt(match[1], 10);

    return (
      window.boostSDFallback?.productPerPage ||
      window.boostSDFallback?.pagination?.page_size ||
      16
    );
  }

  function getCurrentPage() {
    const pageParam = new URLSearchParams(window.location.search).get('page');
    if (pageParam) return Math.max(1, parseInt(pageParam, 10));

    const activePage = document.querySelector(
      '.boost-sd__pagination-number--active, [class*="pagination-number"][class*="active"]'
    );
    if (activePage?.textContent) {
      const page = parseInt(activePage.textContent.trim(), 10);
      if (!Number.isNaN(page)) return page;
    }

    return 1;
  }

  function updateTotalsFromGrid(total, { fromBoost = false } = {}) {
    const items = document.querySelectorAll(
      '.boost-sd__product-item[data-product-id], .boost-sd__fallback-product-item[data-product-id]'
    );
    const visible = items.length;
    if (!visible) return;

    const perPage = getPerPage();
    const page = getCurrentPage();
    const from = (page - 1) * perPage + 1;
    const to = from + visible - 1;
    const finalTotal =
      total ??
      (rsTotals.fromBoost ? rsTotals.total : null) ??
      getInitialProductTotal();

    if (!finalTotal) return;

    if (total) {
      rsTotals.total = total;
      rsTotals.fromBoost = fromBoost || rsTotals.fromBoost;
    }

    rsTotals.from = from;
    rsTotals.to = to;
    ensureProductCount(from, to, finalTotal);
    updatePageSearchCount(finalTotal);
  }

  function updatePageSearchCount(total) {
    const el = document.querySelector('[data-page-search-count]');
    if (!el) return;

    const count = Number(total);
    if (!count) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    el.hidden = false;
    el.textContent = `${String(count).padStart(2, '0')} RESULTS`;
  }

  function hideBoostSearchPageForm() {
    const page = document.querySelector('.boost-sd-container-search-page');
    if (!page) return;

    page.querySelectorAll('form').forEach((form) => {
      if (form.closest('.boost-sd-left, .boost-sd__filter-tree-wrapper')) return;
      if (form.closest('.page-search-bar, .header-search-form, .menu-drawer__search')) return;
      if (!form.querySelector('input[type="search"], input[name="q"]')) return;

      form.hidden = true;
      form.setAttribute('aria-hidden', 'true');
      form.style.setProperty('display', 'none', 'important');
    });

    hideBoostSearchPageHeader(page);
  }

  function hideBoostSearchPageHeader(page) {
    page = page || document.querySelector('.boost-sd-container-search-page');
    if (!page) return;

    const hide = (el) => {
      if (!el) return;
      if (el.closest('.boost-sd-right, .boost-sd-left, .boost-sd__filter-tree-wrapper')) return;
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    };

    page
      .querySelectorAll(
        '.boost-sd-toolbar-product-tab, .boost-sd__search-header, .boost-sd__fallback-search-header, [class*="toolbar-product-tab"], [class*="search-result-header"], [class*="SearchResultHeader"]'
      )
      .forEach(hide);

    const layout = page.querySelector('.boost-sd-layout');
    if (!layout) return;

    let sibling = layout.previousElementSibling;
    while (sibling) {
      const text = sibling.textContent.replace(/\s+/g, ' ');
      if (
        /products\s*\(\s*\d+/i.test(text) ||
        /showing\s+\d+\s+results/i.test(text)
      ) {
        hide(sibling);
      }
      sibling = sibling.previousElementSibling;
    }
  }

  function getToolbarItem(type) {
    return (
      document.querySelector(`.boost-sd__toolbar-item--${type}`) ||
      document.querySelector(`.boost-sd__toolbar-item-${type}`) ||
      document.querySelector(`[class*="toolbar-item"][class*="${type}"]`)
    );
  }

  function getToolbarItemIn(toolbar, type) {
    if (!toolbar) return null;

    return (
      toolbar.querySelector(`.boost-sd__toolbar-item--${type}`) ||
      toolbar.querySelector(`.boost-sd__toolbar-item-${type}`) ||
      toolbar.querySelector(`[class*="toolbar-item"][class*="${type}"]`)
    );
  }

  function getFilterToggleButton(toolbar) {
    return (
      toolbar.querySelector('.boost-sd__filter-tree-toggle-button') || getToolbarItemIn(toolbar, 'filter')
    );
  }

  function groupToolbarControls() {
    const toolbar = getToolbar();
    if (!toolbar) return;

    const displayItem = getToolbarItem('show-limit');
    const sortItem = getToolbarItem('sorting');
    // Boost nests the filter toggle button inside the sorting toolbar item (no
    // separate toolbar-item--filter wrapper) — do NOT relocate it into this
    // group: Boost's own renderer keeps internal references to it and crashes
    // (insertBefore on a detached node) when it re-renders after a move.
    const filterItem = getToolbarItemIn(toolbar, 'filter');

    if (!displayItem && !sortItem && !filterItem) return;

    let controls = toolbar.querySelector('.rs-boost-toolbar-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'rs-boost-toolbar-controls';
      toolbar.appendChild(controls);
    }

    [displayItem, sortItem, filterItem]
      .filter(Boolean)
      .forEach((item) => {
        if (item.parentNode !== controls) {
          controls.appendChild(item);
        }
      });

    [displayItem, sortItem, filterItem]
      .filter(Boolean)
      .forEach((item) => controls.appendChild(item));

    const countItem =
      toolbar.querySelector(
        '.rs-boost-toolbar-count, .boost-sd__toolbar-item-product-count, [class*="toolbar-item"][class*="product-count"]'
      ) || toolbar.querySelector('.rs-boost-showing')?.closest('[class*="toolbar-item"]');

    if (countItem?.parentNode === toolbar && toolbar.firstChild !== countItem) {
      toolbar.insertBefore(countItem, toolbar.firstChild);
    }
  }

  function ensureProductCount(from, to, total) {
    const toolbar = getToolbar();
    if (!toolbar || !from || !to || !total) return;

    let item = toolbar.querySelector(
      '.rs-boost-toolbar-count, .boost-sd__toolbar-item-product-count, [class*="toolbar-item"][class*="product-count"]'
    );
    let countEl = item?.querySelector('.boost-sd__product-count, .rs-boost-showing');

    if (!item) {
      item = document.createElement('div');
      item.className =
        'boost-sd__toolbar-item boost-sd__toolbar-item-product-count rs-boost-toolbar-count';
      countEl = document.createElement('div');
      countEl.className = 'boost-sd__product-count rs-boost-showing';
      item.appendChild(countEl);
      toolbar.insertBefore(item, toolbar.firstChild);
    } else if (item.parentNode === toolbar && toolbar.firstChild !== item) {
      // Once ensureMobileToolbarMeta has moved this item inside
      // .rs-boost-toolbar-meta, leave it there — repositioning it against
      // `toolbar` here would yank it back out and scramble the meta row's
      // left-to-right order (count item vs. CLEAR ALL) on the next pass.
      toolbar.insertBefore(item, toolbar.firstChild);
    }

    enhanceProductCountText(from, to, total, countEl);
    groupToolbarControls();
  }

  function formatShowingText(from, to, total) {
    const formatNum = (n) => Number(n).toLocaleString('en-US');
    return `SHOWING ${formatNum(from)}-${formatNum(to)} OF ${formatNum(total)}`;
  }

  // Boost SD encodes every applied filter as a "pf_<key>=<Facet>: <Value>"
  // query param (repeated per value). On mobile Boost only mounts the
  // refine-by chip list inside the filter drawer while it's open — once
  // closed, `.boost-sd-left`/`.boost-sd__filter-tree-wrapper` is empty and
  // there's nothing to read from the DOM. The URL is the one place the
  // active filter state is reliably available regardless of viewport or
  // whether the drawer has ever been opened, so it's the source of truth
  // for the mobile badge count and chip row.
  var FILTER_PARAM_PREFIX = 'pf_';

  function getActiveFiltersFromURL() {
    var params = new URLSearchParams(window.location.search);
    var filters = [];
    params.forEach(function (value, key) {
      if (key.indexOf(FILTER_PARAM_PREFIX) !== 0) return;
      var colonIndex = value.indexOf(': ');
      var label = colonIndex > -1 ? value.slice(colonIndex + 2) : value;
      filters.push({ key: key, value: value, label: label });
    });
    return filters;
  }

  function removeFilterFromURL(targetKey, targetValue) {
    var params = new URLSearchParams(window.location.search);
    var remaining = params.getAll(targetKey).filter(function (v) {
      return v !== targetValue;
    });
    params.delete(targetKey);
    remaining.forEach(function (v) {
      params.append(targetKey, v);
    });
    params.delete('page');
    window.location.search = params.toString();
  }

  function clearAllFiltersFromURL() {
    var params = new URLSearchParams(window.location.search);
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf(FILTER_PARAM_PREFIX) === 0) params.delete(key);
    });
    params.delete('page');
    window.location.search = params.toString();
  }

  function isMobileToolbar() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function ensureMobileToolbarMeta(toolbar) {
    if (!isMobileToolbar()) return;

    const countItem = toolbar.querySelector(
      '.rs-boost-toolbar-count, .boost-sd__toolbar-item-product-count, [class*="toolbar-item"][class*="product-count"]'
    );
    if (!countItem) return;

    let meta = toolbar.querySelector('.rs-boost-toolbar-meta');
    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'rs-boost-toolbar-meta';
      toolbar.insertBefore(meta, toolbar.firstChild);
    }

    // SHOWING goes left, CLEAR ALL goes right — enforce that DOM order
    // explicitly rather than relying on append timing, since countItem is
    // always meant to lead.
    if (meta.firstChild !== countItem) {
      meta.insertBefore(countItem, meta.firstChild);
    }

    let clearAll = meta.querySelector('.rs-boost-clear-all');

    if (!clearAll) {
      clearAll = document.createElement('button');
      clearAll.type = 'button';
      clearAll.className = 'rs-boost-clear-all';
      clearAll.textContent = 'CLEAR ALL ×';
      meta.appendChild(clearAll);
    } else if (meta.lastChild !== clearAll) {
      meta.appendChild(clearAll);
    }

    if (clearAll.dataset.rsBound !== 'true') {
      clearAll.dataset.rsBound = 'true';
      clearAll.addEventListener('click', clearAllFiltersFromURL);
    }

    clearAll.hidden = getActiveFiltersFromURL().length === 0;
  }

  function renderMobileFilterChips(toolbar) {
    if (!isMobileToolbar()) return;

    const filters = getActiveFiltersFromURL();

    let chips = toolbar.querySelector('.rs-boost-filter-chips');
    if (!filters.length) {
      if (chips) chips.hidden = true;
      return;
    }

    if (!chips) {
      chips = document.createElement('div');
      chips.className = 'rs-boost-filter-chips';
      toolbar.appendChild(chips);
    }

    chips.hidden = false;
    chips.innerHTML = '';

    filters.forEach((filter) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rs-boost-filter-chip';

      const label = document.createElement('span');
      label.className = 'rs-boost-filter-chip__label';
      label.textContent = filter.label;

      const remove = document.createElement('span');
      remove.className = 'rs-boost-filter-chip__remove';
      remove.setAttribute('aria-hidden', 'true');
      remove.textContent = '×';

      chip.appendChild(label);
      chip.appendChild(remove);
      chip.setAttribute('aria-label', `Remove filter ${filter.label}`);
      chip.addEventListener('click', () => removeFilterFromURL(filter.key, filter.value));

      chips.appendChild(chip);
    });
  }

  function decorateMobileToolbarControls(toolbar) {
    if (!isMobileToolbar()) return;

    const sortButton = toolbar.querySelector('.boost-sd__sorting-button');
    if (sortButton && !sortButton.querySelector('.rs-boost-mobile-face--sort')) {
      const face = document.createElement('span');
      face.className = 'rs-boost-mobile-face rs-boost-mobile-face--sort';
      face.innerHTML =
        '<span class="rs-boost-mobile-face__icon rs-boost-mobile-face__icon--sort" aria-hidden="true"></span><span class="rs-boost-mobile-face__label">Sort</span>';
      sortButton.appendChild(face);
      sortButton.classList.add('rs-boost-mobile-has-face');
    }

    const filterItem = getFilterToggleButton(toolbar);
    if (filterItem && !filterItem.querySelector('.rs-boost-mobile-face--filter')) {
      const face = document.createElement('span');
      face.className = 'rs-boost-mobile-face rs-boost-mobile-face--filter';
      face.innerHTML =
        '<span class="rs-boost-mobile-face__icon rs-boost-mobile-face__icon--filter" aria-hidden="true"></span><span class="rs-boost-mobile-face__label">Filter</span><span class="rs-boost-filter-badge" hidden>0</span>';
      filterItem.appendChild(face);
      filterItem.classList.add('rs-boost-mobile-has-face');
    }
  }

  function updateFilterBadge() {
    const count = getActiveFiltersFromURL().length;

    document.querySelectorAll('.rs-boost-filter-badge').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });

    document.querySelectorAll('.rs-boost-clear-all').forEach((clearAll) => {
      clearAll.hidden = count === 0;
    });
  }

  function enhanceMobileToolbar(toolbar) {
    if (!toolbar || !isMobileToolbar()) return;

    ensureMobileToolbarMeta(toolbar);
    decorateMobileToolbarControls(toolbar);
    renderMobileFilterChips(toolbar);
    updateFilterBadge();
  }

  function enhanceProductCountText(from, to, total, target) {
    const el =
      target ||
      document.querySelector('.boost-sd__toolbar-item-product-count .boost-sd__product-count') ||
      document.querySelector('.rs-boost-showing') ||
      document.querySelector('.boost-sd__product-count');

    if (!el || !from || !to || !total) return;

    const formatted = formatShowingText(from, to, total);
    if (el.dataset.rsShowing === formatted) return;

    el.dataset.rsShowing = formatted;
    el.textContent = formatted;
  }

  function enhanceShowLimitButton(button) {
    if (!button) return;

    const list = button.querySelector('ul');
    const activeOption =
      list?.querySelector('[class*="option"][class*="active"]') ||
      list?.querySelector('[class*="active"]');
    const count =
      activeOption?.textContent?.trim() ||
      button.textContent.match(/(\d+)/)?.[1];

    if (!count) return;

    const existingControl = button.querySelector('.rs-boost-toolbar-control');
    const existingValue = existingControl?.querySelector('.rs-boost-toolbar-value')?.textContent?.trim();
    if (existingControl && existingValue === count) return;

    button.dataset.rsLimit = count;

    [...button.childNodes].forEach((node) => {
      if (node !== list) button.removeChild(node);
    });

    const control = document.createElement('span');
    control.className = 'rs-boost-toolbar-control';

    const label = document.createElement('span');
    label.className = 'rs-boost-toolbar-label';
    label.textContent = 'Display: ';

    const value = document.createElement('span');
    value.className = 'rs-boost-toolbar-value';
    value.textContent = count;

    control.append(label, value);
    button.insertBefore(control, list);
  }

  function enhanceSortingLabels() {
    document.querySelectorAll('.boost-sd__sorting-label').forEach((label) => {
      if (label.dataset.rsSortLabel === 'true') return;
      label.dataset.rsSortLabel = 'true';
      label.textContent = 'Sort: ';
    });
  }

  function hideRedundantToolbarCounts(toolbar) {
    if (!toolbar?.querySelector('.rs-boost-showing')) return;

    toolbar.querySelectorAll('[class*="toolbar-item"]').forEach((item) => {
      if (item.classList.contains('rs-boost-toolbar-count')) return;
      if (item.querySelector('.rs-boost-showing')) return;

      const text = item.textContent.trim().replace(/\s+/g, ' ');
      if (/^\d[\d,]*\s+products$/i.test(text)) {
        item.hidden = true;
      }
    });
  }

  function enhanceToolbar() {
    enhanceSortingLabels();

    document.querySelectorAll('.boost-sd__show-limit-list-button').forEach(enhanceShowLimitButton);
    groupToolbarControls();

    const toolbar = getToolbar();
    if (toolbar) hideRedundantToolbarCounts(toolbar);

    const countEl =
      document.querySelector('.boost-sd__toolbar-item-product-count .boost-sd__product-count') ||
      document.querySelector('.rs-boost-showing');

    if (countEl && !countEl.dataset.rsShowing) {
      const text = countEl.textContent.trim();
      const paginationMatch = text.match(
        /showing\s+([\d,]+)\s*[-\u2013]\s*([\d,]+)\s+of\s+([\d,]+)/i
      );

      if (paginationMatch) {
        enhanceProductCountText(
          paginationMatch[1].replace(/,/g, ''),
          paginationMatch[2].replace(/,/g, ''),
          paginationMatch[3].replace(/,/g, ''),
          countEl
        );
      }
    } else if (rsTotals.from && rsTotals.to && rsTotals.total) {
      ensureProductCount(rsTotals.from, rsTotals.to, rsTotals.total);
    } else {
      updateTotalsFromGrid();
    }

    if (toolbar) enhanceMobileToolbar(toolbar);
  }

  let toolbarEnhanceQueued = false;

  function queueEnhanceToolbar() {
    if (toolbarEnhanceQueued) return;
    toolbarEnhanceQueued = true;
    requestAnimationFrame(() => {
      toolbarEnhanceQueued = false;
      const toolbar = getToolbar();
      if (toolbar?.dataset.rsEnhancing === 'true') return;
      if (toolbar) toolbar.dataset.rsEnhancing = 'true';
      try {
        enhanceToolbar();
      } finally {
        if (toolbar) delete toolbar.dataset.rsEnhancing;
      }
    });
  }

  function watchToolbar() {
    const attach = (toolbar) => {
      if (!toolbar || toolbar.dataset.rsToolbarWatch === 'true') return;
      toolbar.dataset.rsToolbarWatch = 'true';
      const observer = new MutationObserver(() => {
        queueEnhanceToolbar();
      });
      observer.observe(toolbar, { childList: true, subtree: true });
      queueEnhanceToolbar();
    };

    const toolbar = getToolbar();
    if (toolbar) {
      attach(toolbar);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const found = getToolbar();
      if (found) {
        attach(found);
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function enhanceSidebar() {
    if (sidebarEnhancing) return;

    const sidebar = getFilterSidebar();
    if (!sidebar) return;

    sidebarEnhancing = true;
    cleanupMisplacedPaginationTiles();
    try {
      enhanceRefineBy();
      enhanceFilterCounts(sidebar);
      const toolbar = getToolbar();
      if (toolbar) enhanceMobileToolbar(toolbar);
    } finally {
      sidebarEnhancing = false;
    }
  }

  function queueEnhanceSidebar() {
    if (sidebarEnhanceQueued) return;
    sidebarEnhanceQueued = true;
    requestAnimationFrame(() => {
      sidebarEnhanceQueued = false;
      enhanceSidebar();
    });
  }

  function watchRefineBy() {
    const attach = (sidebar) => {
      if (!sidebar || sidebar.dataset.rsRefineWatch === 'true') return;
      sidebar.dataset.rsRefineWatch = 'true';
      const observer = new MutationObserver(() => {
        queueEnhanceSidebar();
      });
      observer.observe(sidebar, { childList: true, subtree: true });
      queueEnhanceSidebar();
    };

    const sidebar = getFilterSidebar();
    if (sidebar) {
      attach(sidebar);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const found = getFilterSidebar();
      if (found) {
        attach(found);
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  const RS_PAGINATION = {
    accent: '#e01e26',
    fg: '#15140f',
    line: '#e8e6e0',
    white: '#ffffff',
  };

  function isInsideFilters(el) {
    return Boolean(
      el.closest(
        '.boost-sd-left, .boost-sd__filter-tree-wrapper, [class*="filter-tree"], [class*="filter-option"], [class*="refine-by"]'
      )
    );
  }

  function isInsidePagination(el) {
    return Boolean(
      el.closest('[class*="product-list-pagination"], .boost-sd__fallback-pagination, .rs-pagination')
    );
  }

  function isPaginationTile(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isInsideFilters(el)) return false;

    const className = typeof el.className === 'string' ? el.className : '';
    if (/filter-option|filter-tree|refine-by/i.test(className)) return false;

    if (el.tagName === 'LI' && /pagination-item|fallback-pagination/.test(className)) {
      return true;
    }

    if (el.tagName !== 'BUTTON' && el.tagName !== 'A') return false;

    const text = el.textContent.replace(/\s+/g, ' ').trim();

    if (/^\d+$/.test(text) || text === '...') {
      return isInsidePagination(el) || /pagination/i.test(className);
    }

    if (/pagination-button/i.test(className) || el.closest('[class*="pagination-button"]')) {
      return true;
    }

    if (el.querySelector('.boost-sd__fallback-pagination-icon')) {
      return true;
    }

    return Boolean(el.querySelector('svg') && isInsidePagination(el) && /pagination/i.test(className));
  }

  function findPaginationRoot() {
    return (
      document.querySelector('[class*="product-list-pagination"]') ||
      document.querySelector('.boost-sd__fallback-pagination') ||
      document.querySelector('.rs-pagination')
    );
  }

  function cleanupMisplacedPaginationTiles() {
    document
      .querySelectorAll(
        '.boost-sd-left .rs-pagination__tile, .boost-sd__filter-tree-wrapper .rs-pagination__tile, [class*="filter-option"] .rs-pagination__tile, [class*="filter-tree"] .rs-pagination__tile'
      )
      .forEach((el) => {
        el.classList.remove(
          'rs-pagination__tile',
          'rs-pagination__tile--active',
          'rs-pagination__tile--ellipsis',
          'rs-pagination__tile--arrow',
          'rs-pagination__tile--prev',
          'rs-pagination__tile--next'
        );
      });
  }

  function collectPaginationTiles() {
    const root = findPaginationRoot();
    const tiles = new Set();

    if (root) {
      root
        .querySelectorAll('li.boost-sd__fallback-pagination-item, li[class*="pagination-item"]')
        .forEach((el) => tiles.add(el));

      root.querySelectorAll('button, a').forEach((el) => {
        if (isPaginationTile(el)) tiles.add(el);
      });

      return [...tiles];
    }

    const list =
      document.querySelector('.boost-sd__product-list') ||
      document.querySelector('[class*="product-list-product-list"]');

    if (!list) return [];

    let node = list.nextElementSibling;
    while (node) {
      node.querySelectorAll('button, a').forEach((el) => {
        if (isPaginationTile(el)) tiles.add(el);
      });

      if (tiles.size >= 2) break;
      node = node.nextElementSibling;
    }

    return [...tiles];
  }

  function paginationNumberProps(props = {}) {
    return {
      ...props,
      backgroundColor: RS_PAGINATION.white,
      backgroundColorOnSelected: RS_PAGINATION.accent,
      color: RS_PAGINATION.fg,
      colorOnSelected: RS_PAGINATION.white,
      fontFamily: 'Archivo, sans-serif',
      fontSize: '15px',
      fontWeight: 800,
      shape: 'square',
    };
  }

  function paginationNumberStyle(style, element) {
    const props = element?.getParams?.()?.props || {};
    const isActive = Boolean(props.active);
    const isEllipsis = props.page === '...';

    return {
      ...(style || {}),
      alignItems: 'center',
      backgroundColor: isActive ? RS_PAGINATION.accent : RS_PAGINATION.white,
      border: `1.5px solid ${isActive ? RS_PAGINATION.accent : RS_PAGINATION.line}`,
      borderRadius: '12px',
      boxShadow: 'none',
      boxSizing: 'border-box',
      color: isActive ? RS_PAGINATION.white : RS_PAGINATION.fg,
      cursor: isEllipsis ? 'default' : 'pointer',
      display: 'inline-flex',
      fontFamily: 'Archivo, sans-serif',
      fontSize: '15px',
      fontWeight: '800',
      height: '44px',
      justifyContent: 'center',
      lineHeight: '1',
      margin: '0',
      minHeight: '44px',
      minWidth: '44px',
      padding: isEllipsis ? '0 10px' : '0',
      width: isEllipsis ? 'auto' : '44px',
    };
  }

  function paginationNumberClassName(className, element) {
    const props = element?.getParams?.()?.props || {};
    const classes = ['rs-pagination__tile'];

    if (props.active) classes.push('rs-pagination__tile--active');
    if (props.page === '...') classes.push('rs-pagination__tile--ellipsis');

    return `${className || ''} ${classes.join(' ')}`.trim();
  }

  function paginationButtonProps(props = {}) {
    return {
      ...props,
      backgroundColor: RS_PAGINATION.white,
      backgroundColorOnHover: RS_PAGINATION.white,
      borderColor: RS_PAGINATION.line,
      color: RS_PAGINATION.fg,
      colorOnHover: RS_PAGINATION.accent,
      fontFamily: 'Archivo, sans-serif',
      fontSize: '15px',
      fontWeight: 800,
      shape: 'square',
    };
  }

  function paginationButtonStyle(style) {
    return {
      ...(style || {}),
      alignItems: 'center',
      backgroundColor: RS_PAGINATION.white,
      border: `1.5px solid ${RS_PAGINATION.line}`,
      borderRadius: '12px',
      boxShadow: 'none',
      boxSizing: 'border-box',
      color: RS_PAGINATION.fg,
      display: 'inline-flex',
      fontFamily: 'Archivo, sans-serif',
      fontSize: '15px',
      fontWeight: '800',
      height: '44px',
      justifyContent: 'center',
      lineHeight: '1',
      margin: '0',
      minHeight: '44px',
      minWidth: '44px',
      padding: '0',
      width: '44px',
    };
  }

  function paginationButtonClassName(className, element) {
    const props = element?.getParams?.()?.props || {};
    const modifiers = props.modifiers || {};
    const classes = ['rs-pagination__tile', 'rs-pagination__tile--arrow'];

    if (modifiers.prev || /prev/i.test(className || '')) {
      classes.push('rs-pagination__tile--prev');
    }
    if (modifiers.next || /next/i.test(className || '')) {
      classes.push('rs-pagination__tile--next');
    }

    return `${className || ''} ${classes.join(' ')}`.trim();
  }

  function paginationPageLinkStyle(style) {
    return {
      ...(style || {}),
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '9px',
      justifyContent: 'center',
      marginTop: '42px',
      width: '100%',
    };
  }

  function enhancePaginationTile(btn, currentPage, index, tiles) {
    const text = btn.textContent.replace(/\s+/g, ' ').trim();
    const page = parseInt(text, 10);
    const className = typeof btn.className === 'string' ? btn.className : '';
    const isArrow = Boolean(btn.querySelector('svg, .boost-sd__fallback-pagination-icon'));
    const isEllipsis = text === '...';
    const isActive =
      className.includes('active') ||
      className.includes('current-page') ||
      btn.getAttribute('aria-current') === 'page' ||
      (page === currentPage && !Number.isNaN(page));

    btn.classList.add('rs-pagination__tile');
    btn.classList.remove(
      'rs-pagination__tile--active',
      'rs-pagination__tile--ellipsis',
      'rs-pagination__tile--arrow',
      'rs-pagination__tile--prev',
      'rs-pagination__tile--next'
    );
    btn.classList.toggle('rs-pagination__tile--active', isActive);
    btn.classList.toggle('rs-pagination__tile--ellipsis', isEllipsis);

    if (isArrow) {
      btn.classList.add('rs-pagination__tile--arrow');
      if (className.includes('prev') || /prev/i.test(className)) {
        btn.classList.add('rs-pagination__tile--prev');
      } else if (className.includes('next') || /next/i.test(className)) {
        btn.classList.add('rs-pagination__tile--next');
      }
    }
  }

  function enhancePagination() {
    cleanupMisplacedPaginationTiles();

    const tiles = collectPaginationTiles();
    if (tiles.length < 2) return;

    const root =
      findPaginationRoot() ||
      tiles[0].closest('[class*="product-list-pagination"], .boost-sd__fallback-pagination') ||
      tiles[0].parentElement;

    if (root) {
      root.classList.add('rs-pagination');
    }

    const row = tiles[0].parentElement;
    if (row) {
      row.classList.add('rs-pagination__list');
    }

    const currentPage = getCurrentPage();
    tiles.forEach((btn, index) => {
      enhancePaginationTile(btn, currentPage, index, tiles);
    });
  }

  let paginationEnhanceQueued = false;

  function queueEnhancePagination() {
    if (paginationEnhanceQueued) return;
    paginationEnhanceQueued = true;
    requestAnimationFrame(() => {
      paginationEnhanceQueued = false;
      enhancePagination();
    });
  }

  function watchPagination() {
    const attach = (root) => {
      if (!root || root.dataset.rsPaginationWatch === 'true') return;
      root.dataset.rsPaginationWatch = 'true';

      const observer = new MutationObserver(() => {
        queueEnhancePagination();
      });

      observer.observe(root, { childList: true, subtree: true });
      queueEnhancePagination();
    };

    const root = findPaginationRoot();
    if (root) {
      attach(root);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const found = findPaginationRoot();
      if (found) {
        attach(found);
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function afterRender() {
    enhanceProductCards();
    enhanceToolbar();
    enhancePagination();
    watchPagination();
    watchToolbar();
    queueEnhanceSidebar();
    watchRefineBy();
    hideBoostSearchPageForm();
    if (rsTotals.total) updatePageSearchCount(rsTotals.total);
  }

  const customize = {
    enhancePaginationTotals(componentRegistry) {
      componentRegistry.useComponentPlugin('ProductListPagination', {
        name: 'Record Store collection pagination',
        enabled: true,
        apply: () => ({
          afterRender(element) {
            const props = element?.getParams?.()?.props;
            if (props?.totalProducts) {
              updateTotalsFromGrid(props.totalProducts, { fromBoost: true });
            }
            enhancePagination();
          },
        }),
      });

      componentRegistry.useComponentPlugin('PaginationNumber', {
        name: 'Record Store pagination number tiles',
        enabled: true,
        apply: () => ({
          props: paginationNumberProps,
          style: paginationNumberStyle,
          className: paginationNumberClassName,
          afterRender() {
            queueEnhancePagination();
          },
        }),
      });

      componentRegistry.useComponentPlugin('PaginationButton', {
        name: 'Record Store pagination arrow tiles',
        enabled: true,
        apply: () => ({
          props: paginationButtonProps,
          style: paginationButtonStyle,
          className: paginationButtonClassName,
          afterRender() {
            queueEnhancePagination();
          },
        }),
      });

      componentRegistry.useComponentPlugin('PaginationPageLink', {
        name: 'Record Store pagination layout',
        enabled: true,
        apply: () => ({
          style: paginationPageLinkStyle,
          className: (className) => `${className || ''} rs-pagination__list`.trim(),
          afterRender() {
            queueEnhancePagination();
          },
        }),
      });

      componentRegistry.useComponentPlugin('ProductList', {
        name: 'Record Store collection product total',
        enabled: true,
        apply: () => ({
          afterRender(element) {
            const params = element?.getParams?.();
            const totalProducts =
              params?.props?.totalProducts ?? params?.totalProducts ?? params?.state?.totalProducts;

            if (!totalProducts) return;
            updateTotalsFromGrid(totalProducts, { fromBoost: true });
          },
        }),
      });
    },
    enhanceProductCount(componentRegistry) {
      componentRegistry.useComponentPlugin('ProductCount', {
        name: 'Record Store collection toolbar count',
        enabled: true,
        apply: () => ({
          afterRender(element) {
            const props = element?.getParams?.()?.props;
            if (!props || props.locatedIn !== 'Toolbar') return;

            ensureProductCount(
              props.fromProductIndex,
              props.toProductIndex,
              props.totalProducts
            );
            rsTotals.total = props.totalProducts;
            rsTotals.fromBoost = true;
          },
        }),
      });
    },
    enhanceProductItem(componentRegistry) {
      componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Record Store collection card',
        enabled: true,
        apply: () => ({
          afterRender(element) {
            const product = element?.getParams?.()?.props?.product;
            if (!product?.id) {
              enhanceProductCards();
              return;
            }

            const item = document.querySelector(
              `.boost-sd__product-item[data-product-id="${product.id}"], .boost-sd__fallback-product-item[data-product-id="${product.id}"]`
            );

            enhanceItem(item, product);
          },
        }),
      });
    },
  };

  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.enhancePaginationTotals,
    customize.enhanceProductCount,
    customize.enhanceProductItem,
  ]);

  if (window.boostWidgetIntegration?.regisCustomization) {
    window.boostWidgetIntegration.regisCustomization(afterRender, 'filter');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterRender);
  } else {
    afterRender();
  }

  window.addEventListener('boost-sd-enable-product-filter-fallback', afterRender);
  window.addEventListener('boost-sd-remove-filter-params', queueEnhanceSidebar);
  window.addEventListener('product-list-change', () => {
    queueEnhanceToolbar();
    enhanceProductCards();
    queueEnhancePagination();
    hideBoostSearchPageForm();
  });

  if (document.querySelector('.page-search-bar') && !window.__rsBoostSearchFormWatch) {
    window.__rsBoostSearchFormWatch = true;

    const attachSearchFormWatch = () => {
      const page = document.querySelector('.boost-sd-container-search-page');
      if (!page) return false;
      hideBoostSearchPageForm();
      const observer = new MutationObserver(() => hideBoostSearchPageForm());
      observer.observe(page, { childList: true, subtree: true });
      return true;
    };

    if (!attachSearchFormWatch()) {
      const bodyObserver = new MutationObserver(() => {
        if (attachSearchFormWatch()) bodyObserver.disconnect();
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ─── Mobile filter — bottom sheet + blurred backdrop ────────────────────

  function isMobileFilter() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function getFilterBackdrop() {
    return document.querySelector('.rs-filter-backdrop');
  }

  function sp(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  // Scan the DOM for Boost's visible filter panel. We can't rely on a specific
  // class name because Boost's overlay element varies. Strategy:
  // 1. Walk up from .boost-sd__filter-tree-wrapper looking for positioned ancestor
  // 2. Walk up from .boost-sd-left looking for positioned ancestor
  // 3. Scan all [class*="boost-sd"] for a visible large fixed/absolute element
  // 4. Fall back to .boost-sd-left itself (Boost may make it the overlay)
  function findBoostFilterPanel() {
    const minW = window.innerWidth * 0.25;
    const minH = window.innerHeight * 0.15;

    function walkUp(start) {
      let el = start;
      while (el && el !== document.body) {
        const cs = window.getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'absolute') {
          if (cs.display !== 'none' && cs.visibility !== 'hidden') {
            const r = el.getBoundingClientRect();
            if (r.width >= minW && r.height >= minH) return el;
          }
        }
        el = el.parentElement;
      }
      return null;
    }

    // Walk up from filter tree wrapper
    const wrapper = document.querySelector('.boost-sd__filter-tree-wrapper');
    if (wrapper) {
      const found = walkUp(wrapper);
      if (found) return found;
    }

    // Walk up from boost-sd-left
    const left = document.querySelector('.boost-sd-left');
    if (left) {
      const found = walkUp(left);
      if (found) return found;
    }

    // Broad scan: any visible large positioned boost-sd element
    for (const el of document.querySelectorAll('[class*="boost-sd"]')) {
      if (el === getFilterBackdrop()) continue;
      const cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
      const r = el.getBoundingClientRect();
      if (r.width >= minW && r.height >= minH) return el;
    }

    // Last resort: boost-sd-left itself — Boost makes it the overlay on mobile
    if (left && window.getComputedStyle(left).display !== 'none') return left;

    return null;
  }

  function applyBottomSheetStyles(panel) {
    sp(panel, 'position', 'fixed');
    sp(panel, 'top', 'auto');
    sp(panel, 'right', '0');
    sp(panel, 'bottom', '0');
    sp(panel, 'left', '0');
    sp(panel, 'width', '100%');
    sp(panel, 'max-width', 'none');
    sp(panel, 'height', '80vh');
    sp(panel, 'max-height', '80vh');
    sp(panel, 'border-radius', '20px 20px 0 0');
    sp(panel, 'z-index', '101');
    sp(panel, 'background', '#fff');
    sp(panel, 'overflow', 'hidden');
    sp(panel, 'display', 'flex');
    sp(panel, 'flex-direction', 'column');
    sp(panel, 'align-items', 'stretch');
    sp(panel, 'box-shadow', '0 -8px 40px -8px rgba(0,0,0,0.18)');
    sp(panel, 'transform', 'none');
    sp(panel, 'transition', 'none');
    sp(panel, 'margin', '0');
    sp(panel, 'padding', '0');
    panel.setAttribute('data-rs-filter-panel', 'true');
  }

  // Re-enforce bottom-sheet styles whenever Boost's reactive renderer resets them
  function watchPanelStyles(panel) {
    if (panel.dataset.rsStyleWatcher === 'true') return;
    panel.dataset.rsStyleWatcher = 'true';

    let enforcing = false;
    const obs = new MutationObserver(() => {
      if (enforcing) return;
      if (!panel.hasAttribute('data-rs-filter-panel')) {
        obs.disconnect();
        return;
      }
      // Check if our key style was reset
      if (panel.style.getPropertyValue('bottom') !== '0px' &&
          panel.style.getPropertyValue('bottom') !== '0') {
        enforcing = true;
        applyBottomSheetStyles(panel);
        enforcing = false;
      }
    });
    obs.observe(panel, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  function injectDragHandle(panel) {
    if (panel.querySelector('.rs-filter-handle')) return;
    const handle = document.createElement('div');
    handle.className = 'rs-filter-handle';
    handle.setAttribute('aria-hidden', 'true');
    panel.insertBefore(handle, panel.firstChild);
  }

  // Inject our own header instead of restyling Boost's.
  // Boost's close button (.boost-sd__filter-tree-vertical-close-filter) is a
  // sibling of the header — not inside it — so we can't move it via CSS order.
  // We hide Boost's header + close element and create our own.
  function injectCustomHeader(panel) {
    if (panel.querySelector('[data-rs-filter-header]')) return;

    // Hide Boost's header row (title + clear all).
    // Try class selectors first, then fall back to finding the row by text content.
    const boostHeader = panel.querySelector('[class*="filter-tree-header"]') ||
                        panel.querySelector('[class*="filter"][class*="header"]');
    if (boostHeader) {
      sp(boostHeader, 'display', 'none');
    } else {
      // Fallback: any direct child of panel that contains "Filter By" or "Clear All" text
      for (const child of panel.children) {
        if (child.hasAttribute('data-rs-filter-header') || child.classList.contains('rs-filter-handle')) continue;
        if (/filter\s*by/i.test(child.textContent) || /clear\s*all/i.test(child.textContent)) {
          sp(child, 'display', 'none');
        }
      }
    }

    // Also hide any loose "Clear All" link/button anywhere inside the panel
    panel.querySelectorAll('[class*="clear-all"], [class*="clearAll"]').forEach(el => {
      sp(el, 'display', 'none');
    });

    // Hide Boost's floating close button (absolute-positioned sibling)
    const boostClose = panel.querySelector('[class*="close-filter"]') ||
                       panel.querySelector('[class*="filter-tree-vertical-close"]');
    if (boostClose) sp(boostClose, 'display', 'none');

    // Build our header
    const header = document.createElement('div');
    header.setAttribute('data-rs-filter-header', 'true');
    sp(header, 'display', 'flex');
    sp(header, 'align-items', 'center');
    sp(header, 'gap', '8px');
    sp(header, 'padding', '16px 20px 14px');
    sp(header, 'border-bottom', '1px solid #e8e6e0');
    sp(header, 'flex-shrink', '0');
    sp(header, 'background', '#fff');

    const title = document.createElement('span');
    title.textContent = 'Filter';
    sp(title, 'font-family', "'Archivo', sans-serif");
    sp(title, 'font-size', '22px');
    sp(title, 'font-weight', '800');
    sp(title, 'color', '#15140f');
    sp(title, 'flex', '1 1 auto');
    sp(title, 'line-height', '1.2');

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('data-rs-filter-close', 'true');
    closeBtn.setAttribute('aria-label', 'Close filters');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    // Programmatically trigger Boost's hidden close button so Boost cleans up state
    closeBtn.addEventListener('click', () => {
      const inner = boostClose
        ? (boostClose.querySelector('button, [role="button"]') || boostClose)
        : null;
      if (inner) inner.click();
    });
    sp(closeBtn, 'background', 'none');
    sp(closeBtn, 'border', '0');
    sp(closeBtn, 'padding', '4px');
    sp(closeBtn, 'cursor', 'pointer');
    sp(closeBtn, 'color', '#15140f');
    sp(closeBtn, 'display', 'flex');
    sp(closeBtn, 'align-items', 'center');
    sp(closeBtn, 'justify-content', 'center');
    sp(closeBtn, 'flex-shrink', '0');
    sp(closeBtn, 'width', '32px');
    sp(closeBtn, 'height', '32px');

    header.appendChild(title);
    header.appendChild(closeBtn);

    // Insert after drag handle (which is panel.firstChild after injectDragHandle)
    const dragHandle = panel.querySelector('.rs-filter-handle');
    if (dragHandle) dragHandle.after(header);
    else panel.insertBefore(header, panel.firstChild);
  }

  function transformContent(panel) {
    // .boost-sd__filter-tree-wrapper is the scrollable content area inside the panel.
    // Avoid selecting the panel itself with [class*="filter-tree-vertical"].
    const content = panel.querySelector('.boost-sd__filter-tree-wrapper') ||
                    panel.querySelector('[class*="filter-tree-vertical-content"]') ||
                    panel.querySelector('[class*="filter"][class*="content"]') ||
                    panel.querySelector('[class*="filter"][class*="body"]');
    if (!content || content === panel) return;
    content.setAttribute('data-rs-filter-content', 'true');
    sp(content, 'flex', '1 1 auto');
    sp(content, 'overflow-y', 'auto');
    sp(content, '-webkit-overflow-scrolling', 'touch');
    sp(content, 'padding', '0 20px');
    sp(content, 'min-height', '0');
    sp(content, 'align-self', 'stretch');
  }

  function transformFooter(panel) {
    const showEl =
      panel.querySelector('[class*="show-result"]') ||
      panel.querySelector('[class*="showResult"]') ||
      panel.querySelector('[class*="filter"][class*="footer"]') ||
      panel.querySelector('[class*="filter"][class*="bottom"]');
    if (!showEl) return;

    const footerContainer = (showEl.tagName === 'BUTTON' || showEl.tagName === 'A')
      ? showEl.parentElement
      : showEl;

    footerContainer.setAttribute('data-rs-filter-footer', 'true');
    sp(footerContainer, 'display', 'flex');
    sp(footerContainer, 'align-items', 'center');
    sp(footerContainer, 'gap', '12px');
    sp(footerContainer, 'padding', '14px 20px 20px');
    sp(footerContainer, 'border-top', '1px solid #e8e6e0');
    sp(footerContainer, 'flex-shrink', '0');
    sp(footerContainer, 'background', '#fff');

    const showBtn = (showEl.tagName === 'BUTTON' || showEl.tagName === 'A')
      ? showEl : showEl.querySelector('button, a') || showEl;
    showBtn.setAttribute('data-rs-filter-show', 'true');
    sp(showBtn, 'flex', '1 1 auto');
    sp(showBtn, 'background', '#e01e26');
    sp(showBtn, 'color', '#fff');
    sp(showBtn, 'border', '0');
    sp(showBtn, 'border-radius', '12px');
    sp(showBtn, 'min-height', '48px');
    sp(showBtn, 'font-family', "'Archivo', sans-serif");
    sp(showBtn, 'font-size', '14px');
    sp(showBtn, 'font-weight', '800');
    sp(showBtn, 'cursor', 'pointer');
    sp(showBtn, 'display', 'flex');
    sp(showBtn, 'align-items', 'center');
    sp(showBtn, 'justify-content', 'center');
    sp(showBtn, 'padding', '0 16px');
    sp(showBtn, 'width', '100%');

    if (!footerContainer.querySelector('[data-rs-filter-clear]')) {
      const clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.setAttribute('data-rs-filter-clear', 'true');
      clearBtn.textContent = 'Clear';
      clearBtn.addEventListener('click', clearAllFiltersFromURL);
      sp(clearBtn, 'flex-shrink', '0');
      sp(clearBtn, 'background', '#fff');
      sp(clearBtn, 'color', '#14130f');
      sp(clearBtn, 'border', '1.5px solid #14130f');
      sp(clearBtn, 'border-radius', '12px');
      sp(clearBtn, 'min-height', '48px');
      sp(clearBtn, 'padding', '0 18px');
      sp(clearBtn, 'font-family', "'Archivo', sans-serif");
      sp(clearBtn, 'font-size', '14px');
      sp(clearBtn, 'font-weight', '800');
      sp(clearBtn, 'color', '#15140f');
      sp(clearBtn, 'cursor', 'pointer');
      sp(clearBtn, 'white-space', 'nowrap');
      footerContainer.insertBefore(clearBtn, footerContainer.firstChild);
    }
  }

  function closeFilterBottomSheet() {
    const panel = document.querySelector('[data-rs-filter-panel]');
    if (panel) {
      panel.removeAttribute('data-rs-filter-panel');
      delete panel.dataset.rsStyleWatcher;
    }
    document.querySelector('.rs-filter-handle')?.remove();
    document.querySelector('[data-rs-filter-clear]')?.remove();
    // Also remove any injected rs-filter-backdrop (legacy cleanup)
    document.querySelector('.rs-filter-backdrop')?.remove();
  }

  // Boost's mobile filter uses two elements (always in DOM, shown/hidden via attributes):
  //   .boost-sd__filter-tree-vertical-sticky-overlay — full-screen curtain (position:fixed)
  //   .boost-sd__filter-tree-vertical               — the actual panel (position:absolute)
  // We watch the overlay for display changes to know when the filter opens/closes.
  function watchFilterDrawer() {
    function openSheet(overlay, panel) {
      if (!isMobileFilter()) return;

      // Style Boost's own overlay as our blurred backdrop instead of injecting a new one
      sp(overlay, 'backdrop-filter', 'blur(6px) saturate(0.8)');
      sp(overlay, '-webkit-backdrop-filter', 'blur(6px) saturate(0.8)');
      sp(overlay, 'background', 'rgba(15, 13, 10, 0.45)');
      // Keep overlay BELOW the panel so clicks on filter items reach the panel,
      // not the overlay close handler
      sp(overlay, 'z-index', '100');

      // Transform the panel into a bottom sheet
      applyBottomSheetStyles(panel);
      watchPanelStyles(panel);
      injectDragHandle(panel);
      injectCustomHeader(panel);
      transformContent(panel);
      transformFooter(panel);

      // Clicking the overlay backdrop closes the filter
      if (!overlay.dataset.rsCloseHooked) {
        overlay.dataset.rsCloseHooked = 'true';
        overlay.addEventListener('click', () => {
          const closeBtn = panel.querySelector('[data-rs-filter-close]') ||
                           panel.querySelector('[class*="close"]');
          if (closeBtn) closeBtn.click();
        });
      }
    }

    function attach(overlay, panel) {
      if (overlay.dataset.rsFilterWatch === 'true') return;
      overlay.dataset.rsFilterWatch = 'true';

      // Track last known state so we only act on real open/close transitions.
      // Without this, openSheet()'s own sp(overlay,...) calls re-trigger the observer
      // and Boost's class changes on group-expand fire it spuriously.
      let wasOpen = false;

      const obs = new MutationObserver(() => {
        if (!isMobileFilter()) { closeFilterBottomSheet(); return; }
        const isOpen = window.getComputedStyle(overlay).display !== 'none';
        if (isOpen === wasOpen) return; // No real state change — ignore
        wasOpen = isOpen;
        if (isOpen) openSheet(overlay, panel);
        else closeFilterBottomSheet();
      });
      obs.observe(overlay, { attributes: true, attributeFilter: ['style', 'class'] });

      // Already open on load (e.g. page loaded with filter params in URL)
      if (isMobileFilter() && window.getComputedStyle(overlay).display !== 'none') {
        openSheet(overlay, panel);
      }
    }

    function tryAttach() {
      const overlay = document.querySelector('.boost-sd__filter-tree-vertical-sticky-overlay');
      const panel   = document.querySelector('.boost-sd__filter-tree-vertical');
      if (overlay && panel) { attach(overlay, panel); return true; }
      return false;
    }

    if (!tryAttach()) {
      const bodyObs = new MutationObserver(() => {
        if (tryAttach()) bodyObs.disconnect();
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.addEventListener('resize', () => {
    if (!isMobileFilter()) closeFilterBottomSheet();
  });

  watchFilterDrawer();
})();
